import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../shared/data/queryKeys';
import {
  deleteKnowledge,
  listKnowledge,
  reindexKnowledge,
  uploadKnowledge,
  type KnowledgeListParams,
  type UploadKnowledgeInput,
} from './api';

export function useKnowledgeList(params: KnowledgeListParams) {
  return useQuery({
    queryKey: queryKeys.knowledgeList(params as Record<string, unknown>),
    queryFn: () => listKnowledge(params),
  });
}

export function useUploadKnowledge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UploadKnowledgeInput) => uploadKnowledge(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['knowledge'] });
    },
  });
}

export function useDeleteKnowledge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteKnowledge(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['knowledge'] });
    },
  });
}

export function useReindexKnowledge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => reindexKnowledge(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['knowledge'] });
    },
  });
}
